<template>
  <div id="admin">
    <comp-menu />
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import CompMenu from "./components/CompAdminMenu";

export default {
  name: "App",
  components: {
    CompMenu,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style>
* {
  text-transform: initial;
}
.v-list-group__header__prepend-icon {
  margin-right: 10px;
}
</style>